import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IFillSelect } from '../interface/generic/IFillSelect';
import { ICourt } from '../interface/court/ICourt';
import { IDocument } from '../interface/IDocument';
import { IUpdateCourtBatchResponse } from '../interface/court/IUpdateCourtBatchResponse';
import { saveByteArray } from 'src/util/saveByteArray';

enum CourtServiceEnum {
	base = '/',
	getById = '/',
	getCourtsByType = '/by-type?',
	updateBatch = '/update-court-batch',
	generateCourtReport = '/generate-court-report',
	approveCourtBatch = '/approve-court-batch?updateCourtId=',
}

export default class CourtService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/court');
	}

	public getAll = async (): Promise<IFillSelect[]> => await this.GET(CourtServiceEnum.base);
	public getCourtsByType = async (idCourtType: number, onlyActive: boolean): Promise<IFillSelect[]> => await this.GET(CourtServiceEnum.getCourtsByType + `idCourtType=${idCourtType}&onlyActive=${onlyActive}`);
	public getById = async (courtId: number): Promise<ICourt> => await this.GET(CourtServiceEnum.getById + courtId);
	public create = async (data: ICourt): Promise<ICourt> => await this.POST(CourtServiceEnum.base, data);
	public update = async (data: ICourt): Promise<ICourt> => await this.PUT(CourtServiceEnum.base, data);
	public updateBatch = async (file: IDocument): Promise<IUpdateCourtBatchResponse> => await this.POST(CourtServiceEnum.updateBatch, file);
	public approveBatch = async (updateCourtId: number): Promise<any> => await this.PUT(CourtServiceEnum.approveCourtBatch + updateCourtId);
	public generateCourtReport = async () => {
		const data = await this.GET(CourtServiceEnum.generateCourtReport, "blob");
		saveByteArray("tribunais.xlsx", data);
		return data;
	};

}
